<p-treeTable [value]="files">
  <ng-template pTemplate="header">
    <tr>
      <th>Technologies</th>
      <th>Experience</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
    <tr>
      <td>
        <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
        {{ rowData.name }}
      </td>
      <td>{{ rowData.experience }}</td>
    </tr>
  </ng-template>
</p-treeTable>
